import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './PlanLoaderSlideV9.css';

function PlanLoaderSlideV9({ onContinue, steps }) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (progress === 100) {
            const timer = setTimeout(onContinue, 800);

            return () => clearTimeout(timer);
        }

        const timer = setTimeout(() => setProgress(prev => prev + 1), 100);

        return () => clearTimeout(timer);
    }, [progress]);

    const stepIndex = Math.max(0, Math.ceil(progress * steps.length / 100) - 1);

    return (
        <section className={styles.root}>
            <div className={styles.ring}>
                <svg viewBox='0 0 100 100' className={styles.svg} aria-hidden='true'>
                    <circle
                        cx='50'
                        cy='50'
                        r='46'
                        className={styles.track}
                    />
                    <circle
                        cx='50'
                        cy='50'
                        r='46'
                        pathLength='100'
                        strokeDasharray={`${progress} 100`}
                        className={styles.fill}
                    />
                </svg>
                <p className={styles.percent}>{progress}%</p>
            </div>
            <h1 className={styles.caption}>{steps[stepIndex]}</h1>
        </section>
    );
}

PlanLoaderSlideV9.propTypes = {
    onContinue: PropTypes.func.isRequired,
    steps: PropTypes.arrayOf(PropTypes.string).isRequired
};

export {
    PlanLoaderSlideV9
};
